export default __webpack_public_path__ + "static/media/147.c8621e60.jpg";